import React, { useState } from 'react';
import { Container, Carousel, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { FaEye, FaGlasses, FaChild } from 'react-icons/fa';
import { motion } from 'framer-motion'; // Importă framer-motion
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [formErrors, setFormErrors] = useState({});
  const [showForm, setShowForm] = useState(false); // Starea pentru afișarea formularului

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name) errors.name = 'Numele este necesar';
    if (!formData.email) errors.email = 'Email-ul este necesar';
    if (!formData.phone) errors.phone = 'Telefonul este necesar';
    if (!formData.message) errors.message = 'Mesajul este necesar';
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      alert('Formular trimis cu succes!');
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    } else {
      setFormErrors(errors);
    }
  };

  return (
    <div>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <Carousel id="home">
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="./Imagini/cami1.jpeg"
              alt="Slide 1"
            />
            <Carousel.Caption>
              <h3>Îngrijire Oftalmologică de Calitate</h3>
              <p>Ne pasă de sănătatea ochilor tăi.</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="./imagini/cami2.jpeg"
              alt="Slide 2"
            />
            <Carousel.Caption>
              <h3>Ochelari pentru Toate Vârstele</h3>
              <p>Gama variată de rame și lentile.</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="./Imagini/cami3.jpeg"
              alt="Slide 3"
            />
            <Carousel.Caption>
              <h3>Profesionalism și Experiență</h3>
              <p>Echipa noastră este aici pentru tine.</p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </motion.div>

      {/* Servicii Section with Zoom animation on cards */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <Container id="services" className="content">
          <h2>Serviciile Noastre</h2>
          <Row className="services">
            {[
              {
                icon: <FaEye size={40} className="service-icon" />,
                title: 'Consult Oftalmologic',
                text: 'Consultații oftalmologice complete realizate de specialiști cu experiență.'
              },
              {
                icon: <FaGlasses size={40} className="service-icon" />,
                title: 'Ochelari de vedere',
                text: 'Gama variată de rame și lentile de înaltă calitate pentru toate nevoile.'
              },
              {
                icon: <FaChild size={40} className="service-icon" />,
                title: 'Consultații pentru copii',
                text: 'Servicii dedicate copiilor pentru o îngrijire oftalmologică corespunzătoare.'
              }
            ].map((service, index) => (
              <Col md={4} key={index}>
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                >
                  <Card className="service">
                    <Card.Body>
                      {service.icon}
                      <Card.Title>{service.title}</Card.Title>
                      <Card.Text>{service.text}</Card.Text>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </motion.div>

      {/* Despre Noi Section with fade-in effect */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <Container id="about" className="content">
        <h2>Despre noi</h2>
        <p>Bine ai venit la OptiZak, destinația ta de încredere pentru toate nevoile de îngrijire a vederii! La OptiZak, ne dedicăm complet sănătății ochilor tăi, oferindu-ți cele mai avansate soluții optice într-un mediu prietenos și profesionist.</p>
        <h2>Ce ne face diferiți?</h2>
        <p>Consultanță Personalizată: Echipa noastră de optometriști și specialiști în optică, si Medic Oftalmolog este pregătită să îți ofere o consultanție individualizata, luând în considerare toate nevoile tale și oferindu-ți cele mai bune recomandări pentru sănătatea ochilor tăi.</p>
        <p>Găsește-ți Stilul: De la ochelari de vedere si ochelari de soare la lentile de contact, avem o gamă variată de produse moderne și elegante, adaptate stilului și preferințelor tale personale. Lucrează cu experții noștri pentru a găsi produsul care ți se potrivește cel mai bine.</p>
        <p>Tehnologie de Ultimă Oră: Folosim cele mai recente tehnologii pentru diagnosticare și corectare, asigurându-ne că beneficiezi de cele mai precise examene de vedere și cele mai inovatoare soluții optice disponibile pe piață.</p>
        <p>Confort și Îngrijire: La OptiZak, confortul tău este prioritatea noastră. De la momentul în care intri în cabinetul nostru și până la finalizarea tratamentului, ne asigurăm că te simți confortabil și bine îngrijit.</p>
        <p>Visezi la o vedere clară și o experiență plăcută? Vizitează OptiZak și descoperă cum putem îmbunătăți calitatea vederii tale. Te așteptăm cu drag!</p>
      </Container>
      </motion.div>

     {/* Echipa Noastră Section with fade-in effect */}
<motion.div
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 1 }}
  viewport={{ once: true }}
>
  <Container id="team" className="content">
    <h2 className="text-center mb-4">Echipa noastră</h2>
    <Row className="justify-content-center"> {/* Centrare a echipei */}
      {[
        {
          name: 'Camelia Zaharia',
          role: 'Optometrist',
          imgSrc: '/imagini/Camelia Zaharia.jpg'
        },
        {
          name: 'Dr. Petcu Mihai',
          role: 'Dr. Oftalmolog',
          imgSrc: '/imagini/D Mihai Petcu.jpg'
        },
        {
          name: 'Ungureanu Loredana',
          role: 'Optometrist',
          imgSrc: '/imagini/loredana Ungureanu.jpg'
        },
        
      ].map((member, index) => (
        <Col md={4} sm={6} xs={12} className="mb-4" key={index}> {/* Adaugă colțuri responsive */}
          <Card className="team-member h-100 text-center">
            <Card.Img 
              variant="top" 
              src={member.imgSrc} 
              className="rounded-circle mx-auto" 
              style={{ width: '150px', height: '150px', objectFit: 'cover' }} 
            />
            <Card.Body>
              <Card.Title>{member.name}</Card.Title>
              <Card.Text>{member.role}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  </Container>
</motion.div>

      

      <Container id="testimonials" className="content testimonials">
        <h2>Ce spun clienții noștri</h2>
        <div className="testimonial">
          <p>"Am fost foarte mulțumit de serviciile oferite de OptoZak. Personalul este extrem de profesionist și prietenos."</p>
          <div className="testimonial-footer">- Maria Popa</div>
        </div>
        <div className="testimonial">
          <p>"Ochelarii recomandați de Dr. Popescu sunt perfecți pentru mine. Vă mulțumesc!"</p>
          <div className="testimonial-footer">- Ion Ionescu</div>
        </div>
        <div className="testimonial">
          <p>"Fiul meu a avut parte de cea mai bună îngrijire. Recomand cu încredere!"</p>
          <div className="testimonial-footer">- Elena Radu</div>
        </div>
      </Container>

      <Container id="contact" className="content">
        <h2>Contactează-ne</h2>
        <Button onClick={() => setShowForm(!showForm)} className="mb-4">
          {showForm ? 'Ascunde formularul' : 'Afișează formularul'}
        </Button>
        {showForm && (
          <Form onSubmit={handleSubmit} className="contact-form">
            <Row>
              <Col md={6}>
                <Form.Group controlId="formName">
                  <Form.Label>Nume</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    isInvalid={formErrors.name}
                    placeholder="Introdu numele tău"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={formErrors.email}
                    placeholder="Introdu adresa de email"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group controlId="formPhone">
                  <Form.Label>Telefon</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    isInvalid={formErrors.phone}
                    placeholder="Introdu numărul de telefon"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.phone}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formMessage">
                  <Form.Label>Mesaj</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="message"
                    rows={3}
                    value={formData.message}
                    onChange={handleChange}
                    isInvalid={formErrors.message}
                    placeholder="Introdu mesajul tău"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit">Trimite</Button>
          </Form>
        )}
      </Container>

    </div>
  );
}

export default App;
